import React, { Component } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { Grid, Button, Popup, Header, Icon, Advertisement } from "semantic-ui-react";
import CircuitName from "./CircuitName";
import UserName from "./Card";
import AdSense from 'react-adsense';
import { BasicAd } from "./BasicAd";
import SponsorBanner from "./SponsorBanner";

class ShowOff extends Component {
    captureOutboundLink = function (url) {
        if (typeof gtag === "function") {
            gtag("event", "pcbgogo", { "event_category": "3d ads", "event_label": "pcbgogo" });
        }
    }
    render() {
        const { sponsor_ad } = this.props;
        const thumbnails = (
                <Grid verticalAlign="middle" middele="'true'" columns={12} stackable={false}
                    style={{ minHeight: this.props.show_ads ? 95 : 60, paddingTop: 2, backgroundColor: 'var(--muted)', paddingLeft: 15 }}>
                    {
                        this.props.featured_experiments.map((experiment, index) =>
                            index < (this.props.show_ads ? 6 : 6) && <Grid.Column key={index} style={{ padding: 0 }}>
                                <Popup
                                    position={index == 0 ? 'bottom left' : 'bottom center'}
                                    hoverable
                                    flowing
                                    pinned={true}
                                    trigger={

                                        <Button href={experiment.url} target='_blank' style={{ padding: 3 }}>
                                            <div className="side-crop">
                                                <LazyLoadImage
                                                    onError={(event) => event.target.src = ''}
                                                    alt={experiment.alt}
                                                    style={{ maxHeight: 55, minHeight: 55 }}
                                                    src={experiment.thumbnail_url} // use normal <img> attributes as props
                                                />
                                            </div>
                                        </Button>

                                    }>


                                    <a href={experiment.url} target='_blank'><h4>{experiment.name}</h4></a>

                                    <UserName width={400} color='var(--foreground)' creator={experiment.creator} />

                                </Popup>
                            </Grid.Column>
                        )
                    }
                </Grid>
        );
        if (!sponsor_ad) {
            return <div id="show-off">{thumbnails}</div>;
        }
        return (
            <div id="show-off" className="sponsor-row" style={{ backgroundColor: 'var(--muted)' }}>
                <div className="sponsor-row__content">{thumbnails}</div>
                <SponsorBanner sponsor_ad={sponsor_ad} l={this.props.l} onLayoutChange={this.props.onSponsorLayoutChange} />
            </div>
        );
    }
}

export default ShowOff;
